import { siteInfo } from '@/mocks/home';

const footerLinks = [
  {
    title: '影视分类',
    links: [
      { label: '电影', href: '#cards' },
      { label: '电视剧', href: '#cards' },
      { label: '综艺', href: '#cards' },
      { label: '动漫', href: '#cards' },
      { label: '纪录片', href: '#cards' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '热门推荐', href: '#cards' },
      { label: '热播排行', href: '#ranking' },
      { label: '精彩预告', href: '#media' },
      { label: '精选专题', href: '#carousel' },
      { label: 'APP下载', href: '#app' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '用户评价', href: '#comments' },
      { label: '关于我们', href: '#about' },
      { label: '最新动态', href: '#updates' },
    ],
  },
];

export default function Footer() {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      id="footer"
      className="bg-background-50 border-t border-background-300/40"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" onClick={(e) => handleLinkClick(e, '#hero')} className="inline-block">
              <span className="font-heading text-2xl font-bold text-primary-500">90影院</span>
            </a>
            <p className="text-xs md:text-sm text-foreground-400 mt-3 leading-relaxed">
              {siteInfo.footerAbout}
            </p>
            <p className="text-xs text-foreground-500 mt-2">{siteInfo.tagline}</p>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleLinkClick(e, link.href)}
                      className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="mt-10 pt-8 border-t border-background-300/30">
          <h4 className="text-xs font-semibold text-foreground-500 mb-2">合作伙伴</h4>
          <p className="text-xs text-foreground-600">虚位以待，诚邀优质影视内容方与品牌方合作</p>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] md:text-xs text-foreground-600">
            &copy; 2018 - 2024 90影院. All rights reserved. 本站内容仅供学习交流，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#hero"
              onClick={(e) => handleLinkClick(e, '#hero')}
              className="text-[11px] text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              返回顶部
            </a>
            <span className="text-foreground-700">|</span>
            <a
              href="#about"
              onClick={(e) => handleLinkClick(e, '#about')}
              className="text-[11px] text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}